import { OperationReportForm3Container } from "../../../containers/SupportSystem/OperationReportForm/OperationReportForm3Container"
export function OperationReportForm3Page () {
    return(
        <OperationReportForm3Container/>
    )
}